import './style.css'
import { Canvas, useThree } from '@react-three/fiber'
import { Suspense } from 'react'
import { Loader } from '@react-three/drei'
import { Analytics } from '@vercel/analytics/react'
import ReactDOM from 'react-dom/client'
import Firebase from './firebase.jsx'
import UI from './UI.jsx'
import App from './app'


const root = ReactDOM.createRoot(document.querySelector('#root'))

Firebase()


root.render(
<>       <Suspense fallback={[null]}> 
            <Canvas className="r3f" shadows camera={{position: [50, 25, 50], fov: 60}} >
                
                    <App />
                
                <Analytics />

            </Canvas>
        </Suspense>
        
        <UI/>
        <Loader/>
        
    </>
)


